import React, { useState, useEffect } from "react";
import { Link } from 'react-router-dom';
import Loader from '../../../components/Loader.js';
import QuoteRequestSelect from '../../../components/DistrictQuote/districtQuoteRequest.js';
import { formatDateTimeForUserTimeZone } from '../../../helpers/DateTimeFormatter';
import { updateTitle } from '../../../helpers/titleHelper';
import { getManufacturerQuotes, getAllDistricts } from "../../../api/manufacturersapi.js";
import { getAll } from "../../../api/schoolsApi.js";

export function ManufacturerQuoteRequests() {
    updateTitle('Admin', 'Manufacturer Quote Requests');
    const [loadingData, setLoadingData] = useState(true);
    const [filter, setFilter] = useState({ start: 1, length: 100, search: '', status: -1, sort: 1, isdistrictRequest: true, user: true, isMyAccountPage: true, schoolId: 0, districtId: 0 });
    const [quotes, setQuotes] = useState({ total: 0, results: [] });
    const [expandedQuoteId, setExpandedQuoteId] = useState(null);   
    const [schools, setSchools] = useState([]);   
    const [districts, setDistricts] = useState([]);   

    useEffect(() => {
        fetchSchools();
        fetchDistricts();
    }, []);

    useEffect(() => {
        getManufacturerQuotes(filter)
            .then((response) => {
                setQuotes(response.data.data);
                setLoadingData(false);
            });
    }, [filter]);

    const fetchSchools = async () => {
        try {
            const response = await getAll();
            if (response.data.success) {
                setSchools(response.data.data);
            }
        } catch (error) {
            console.error('Error fetching schools:', error);
        }
    };

    const fetchDistricts = async () => {
        try {
            const response = await getAllDistricts();
            if (response.data.success) {
                setDistricts(response.data.data);
            }
        } catch (error) {
            console.error('Error fetching schools:', error);
        }
    };

    const generatePageNumbers = () => {
        const pageNumbers = [];
        for (let i = 1; i <= Math.ceil(quotes.total / filter.length); i++) {
            pageNumbers.push(
                <button key={i}
                    onClick={() => { setFilter({ ...filter, start: filter.start + filter.length }); }}
                    className={Math.floor(filter.length) === i ? 'active' : ''}>{i}
                </button>
            );
        }
        return pageNumbers;
    };

    return (
        <div className="admin-page-wrap">
            <div className="admin-top-bar-wrap">      
            </div>
            <div className="admin-page-content">
                <h1 className="admin-page-heading">Quote Requests</h1>
                {loadingData ? <Loader /> :
                    <div>
                        <div className="admin-bottom-bar">
                            <div className="admin-bottom-bar-left">
                                <input className="admin-default-search quoteradius"
                                    type="text"
                                    placeholder="search users"
                                    id="manufacturer-name"
                                    value={filter.search}
                                    onChange={(e) => setFilter({ ...filter, search: e.target.value })} />
                            </div>
                            <div className="admin-bottom-bar-right">
                                <div>
                                    <select className="admin-default-select" value={filter.districtId} onChange={(e) => setFilter({ ...filter, districtId: parseInt(e.target.value) })}>
                                        <option value="0">Select District</option>
                                        {districts.map((district) => (
                                            <option key={district.id} value={district.id}>{district.name}</option>
                                        ))}
                                    </select>
                                </div>                                
                            </div>
                            <div className="admin-bottom-bar-right">
                                <div>
                                    <select className="admin-default-select" value={filter.schoolId} onChange={(e) => setFilter({ ...filter, schoolId: parseInt(e.target.value) })}>
                                        <option value="0">Select School</option>
                                        {schools.map((school) => (
                                            <option key={school.baseId} value={school.baseId}>{school.name}</option>
                                        ))}
                                    </select>
                                </div>                                
                            </div>
                            <div className="admin-bottom-bar-right">
                                <div>
                                    <QuoteRequestSelect id="quote-status" selectedId={filter.status}
                                        onChange={(e) => setFilter({ ...filter, status: parseInt(e.target.value) })} />
                                </div>                                
                            </div>
                        </div>


                        <div className="admin-table-wrap">
                            <table className="admin-table">
                                <thead>
                                    <tr>
                                        <th onClick={() => setFilter({ ...filter, sort: filter.sort == 0 ? 1 : 0 })} className={filter.sort == 0 ? 'admin-table-name-cell sortable sorted-dn' : (filter.sort == 1 ? 'admin-table-name-cell sortable sorted-up' : 'admin-table-name-cell sortable')}>Quote</th>
                                        <th onClick={() => setFilter({ ...filter, sort: filter.sort == 8 ? 9 : 8 })} className={filter.sort == 8 ? 'admin-table-name-cell sortable sorted-dn' : (filter.sort == 9 ? 'admin-table-name-cell sortable sorted-up' : 'admin-table-name-cell sortable')}>District</th>
                                        <th onClick={() => setFilter({ ...filter, sort: filter.sort == 12 ? 13 : 12 })} className={filter.sort == 12 ? 'admin-table-name-cell sortable sorted-dn' : (filter.sort == 13 ? 'admin-table-name-cell sortable sorted-up' : 'admin-table-name-cell sortable')}>Project Name</th>

                                        <th onClick={() => setFilter({ ...filter, sort: filter.sort == 2 ? 3 : 2 })} className={filter.sort == 2 ? 'admin-table-name-cell sortable sorted-dn' : (filter.sort == 3 ? 'admin-table-name-cell sortable sorted-up' : 'admin-table-name-cell sortable')}>Email</th>
                                        <th onClick={() => setFilter({ ...filter, sort: filter.sort == 4 ? 5 : 4 })} className={filter.sort == 4 ? 'admin-table-name-cell sortable sorted-dn' : (filter.sort == 5 ? 'admin-table-name-cell sortable sorted-up' : 'admin-table-name-cell sortable')}>Submit Date</th>
                                        <th className="admin-table-name-cell">Items in Quote</th>
                                        <th onClick={() => setFilter({ ...filter, sort: filter.sort == 6 ? 7 : 6 })} className={filter.sort == 6 ? 'admin-table-name-cell sortable sorted-dn' : (filter.sort == 7 ? 'admin-table-name-cell sortable sorted-up' : 'admin-table-name-cell sortable')}>Status</th>
                                        <th className="admin-table-action-cell">&nbsp;</th>                              
                                    </tr>
                                </thead>
                                <tbody>                                
                                    {quotes.results && quotes.results.length > 0 ? (
                                        quotes.results.map((quote) => {
                                            const isExpanded = expandedQuoteId === quote.id;
                                            return (
                                                <React.Fragment key={quote.id}>                                           
                                                    <tr
                                                        onClick={() => setExpandedQuoteId(isExpanded ? null : quote.id)}
                                                        className="clickable-row"
                                                        style={{ cursor: 'pointer' }}
                                                    >
                                                        <td className="admin-table-name-cell">{quote?.districtId + '-' + ("000" + quote.id).slice(-4)}</td>
                                                        <td className="admin-table-name-cell">{quote?.districtName}</td>
                                                        <td className="admin-table-name-cell">{quote?.label || 'My Project'}</td>
                                                        <td className="admin-table-name-cell">{quote?.email}</td>
                                                        <td className="admin-table-name-cell">{formatDateTimeForUserTimeZone(quote?.created)}</td>
                                                        <td className="admin-table-name-cell">{quote?.totalQuantity}</td>
                                                        <td className="admin-table-name-cell">{quote?.statusText}</td>
                                                        <td className="admin-table-name-cell nowrap">
                                                            <Link className="default-cta" to={`/my-quote/${quote.id}`}>
                                                                View/Edit Project
                                                            </Link>
                                                        </td>                                                        
                                                    </tr>

                                                    {/* Subquotes */}
                                                    {isExpanded && quote.subQuotes?.map((sub, idx) => (
                                                        <tr key={`sub-${sub.id || idx}`} className="subquote-row">
                                                            <td className="admin-table-name-cell ps-4"> ({quote.districtId}-{("000" + quote.id).slice(-4)}.{("0" + (idx + 1)).slice(-2)})</td>
                                                            <td className="admin-table-name-cell">{sub.districtName}</td>
                                                            <td className="admin-table-name-cell">{sub.label || 'Sub Project'}</td>
                                                            <td className="admin-table-name-cell">{sub.email}</td>
                                                            <td className="admin-table-name-cell">{formatDateTimeForUserTimeZone(sub.created)}</td>
                                                            <td className="admin-table-name-cell">{sub.totalQuantity}</td>
                                                            <td className="admin-table-name-cell">{sub.statusText}</td>
                                                            <td className="admin-table-name-cell nowrap">
                                                                <Link to={`/my-quote/${sub.id}`} target="_blank" rel="noopener noreferrer">
                                                                    {sub.status === 0 ? 'Edit' : 'View'}
                                                                </Link>
                                                            </td>                                                         
                                                        </tr>
                                                    ))}
                                                </React.Fragment>
                                            );
                                        })
                                    ) : (
                                        <tr>
                                            <td className="admin-table-name-cell" colSpan="6">No active quotes or requests</td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>

                        {(quotes.total / filter.length) > 1 ? (
                            <div>
                                <button
                                    onClick={() => setFilter({ ...filter, start: filter.start - filter.length })}
                                    disabled={filter.start == 1}>Previous
                                </button>
                                {generatePageNumbers()}
                                <button
                                    onClick={() => setFilter({ ...filter, start: filter.start + filter.length })}
                                    disabled={filter.start - 1 + filter.length >= quotes.total}>Next
                                </button>
                            </div>
                        ) : ""

                        }

                    </div>
                }
            </div>
        </div>
    );
}